import { z } from "zod";
// ---------------------------------------------------------------------------
// Delta — represents a single insert or delete operation in a text buffer
// ---------------------------------------------------------------------------
/**
 * Longueur maximale d'un TOUR (AGENTS.md §5) — source de vérité unique,
 * partagée client/serveur.
 *
 * Le serveur l'applique À LA FRAPPE : un delta qui ferait déborder le tampon de
 * frappe est refusé (`error` / `TURN_TOO_LONG`) et le tour déjà tapé reste
 * gravable. Le composer s'en sert comme `maxLength`, pour que la frappe s'arrête
 * au même endroit des deux côtés (sinon le texte local et le texte gravé
 * divergent silencieusement).
 */
export const MAX_TURN_LENGTH = 10000;
// US-M4 — borne de sécurité sur le payload d'un delta. Un tour est plafonné à
// MAX_TURN_LENGTH ; un insert plus gros ne pourrait de toute façon jamais être
// gravé. On le rejette DÈS la validation (parseClientMessage échoue → drop)
// pour qu'un payload massif ne soit ni diffusé au pair, ni publié sur Redis, ni
// mis en tampon RAM. Un collage légitime d'un message entier reste accepté.
export const MAX_DELTA_TEXT_LENGTH = MAX_TURN_LENGTH;
export const InsertDeltaSchema = z.object({
    kind: z.literal("insert"),
    pos: z.number().int().nonnegative(),
    text: z.string().min(1).max(MAX_DELTA_TEXT_LENGTH),
    ts: z.number(),
});
export const DeleteDeltaSchema = z.object({
    kind: z.literal("delete"),
    pos: z.number().int().nonnegative(),
    len: z.number().int().positive(),
    ts: z.number(),
});
export const DeltaSchema = z.discriminatedUnion("kind", [
    InsertDeltaSchema,
    DeleteDeltaSchema,
]);
//# sourceMappingURL=delta.js.map